import React, { useState, useEffect, Suspense } from 'react';
import { Container, createStyles, Grid, makeStyles, Theme, Typography, Button } from '@material-ui/core';
import { useImage } from 'react-image';
import { useQuery } from '@apollo/client';
import { GET_MATERIAL_IMAGES_BY_SUB_CATEGORY_ID } from '../../../../../quries/material';
import Masonry from 'react-masonry-css';
import styled from 'styled-components';

import Lightbox from 'react-image-lightbox';
import ImageMasonryGrid from '../ImagesLayout/ImageMasonryGrid';
import { GET_CITIZEN_IMAGES_BY_ID } from '../../../../../quries/citizenJoy';

interface SeparteImageProps {
  //   rowData: any;
  id: any;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    videoBigTitle: {
      fontSize: 24,
      fontWeight: 900,
      fontFamily: 'Noto Sans KR',
      paddingBottom: 16,
      [theme.breakpoints.down('xs')]: { paddingBottom: 8 },
    },
    imgContainer: {
      [theme.breakpoints.down('xs')]: { padding: 0 },
    },
  }),
);

function SeparteImage({ id }: SeparteImageProps) {
  const classes = useStyles();
  const [state, setState] = useState<any[]>([]);
  //   const [imgArray, setImgArray] = useState<any>(null);
  const [imgIndex, setImgIndex] = useState<number>(0);
  const [limitIndex, setLimitIndex] = useState<number>(5);
  //   const [isOpen, setIsOpen] = useState<Boolean>(false);
  const [arrayNumber, setArraynumber] = useState<number>(1);

  const { data, loading, error } = useQuery(GET_CITIZEN_IMAGES_BY_ID, {
    fetchPolicy: 'no-cache',

    variables: {
      where: {
        citizen_joy_program: {
          id: id,
        },
      },
      limit: limitIndex,
      start: imgIndex,
      sort: 'created_at:DESC',
    },
  });

  useEffect(() => {
    if (data && data.citizenJoyImages) {
      setState((prev: any) => {
        console.log(prev);
        return [...prev, ...data.citizenJoyImages];
      });

      setArraynumber(data.citizenJoyImages.length);
      //   setCitizenJoyProgramProgram(data.citizenJoyImages);
    }

    return () => {
      //   setCitizenJoyProgramProgram(null);
    };
  }, [id, data]);
  //   useEffect(() => {
  //     setImgArray(imgArr);

  //     return () => {
  //       setImgArray(null);
  //     };
  //   }, [imgArr]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.citizenJoyImages) {
    console.log(error);
  }

  const testQuery = () => {
    setLimitIndex(2);
    const number = imgIndex;
    setImgIndex(number + limitIndex);
 
  };

  return (
    <Container maxWidth={false} disableGutters={true}>
      <Grid alignItems="center" justify="center" xs={12} container item className={classes.imgContainer}>
        {state ? (
          <React.Fragment>
            <Grid xs={12} item>
              <p className={classes.videoBigTitle}>사진 자료</p>
            </Grid>

            {state && state.length > 0 ? (
              state.map((element: any, index: any) => {
                return <ImageMasonryGrid element={element} key={`citzen-image-material-${index}`} />;
              })
            ) : (
              <div></div>
            )}
          </React.Fragment>
        ) : (
          <div></div>
        )}
        {arrayNumber >= 1 ? <Button onClick={testQuery}>더보기</Button> : <div></div>}
      </Grid>
    </Container>
  );
}
export default SeparteImage;
